import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Erreur inconnue" };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("UI ErrorBoundary", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="app-error-boundary" className="min-h-screen bg-[#060A14] text-slate-50">
          <div className="mx-auto max-w-3xl px-6 py-12">
            <Card data-testid="app-error-card" className="border-white/10 bg-white/[0.08]">
              <CardHeader>
                <CardTitle data-testid="app-error-title" className="text-slate-50">Une erreur est survenue</CardTitle>
              </CardHeader>
              <CardContent className="space-y-3">
                <div data-testid="app-error-message" className="text-sm text-slate-200">
                  {this.state.message}
                </div>
                <div className="text-xs text-slate-300">
                  Astuce : faites un rechargement complet (Ctrl+F5 / Cmd+Shift+R). Si le problème persiste, envoyez une capture.
                </div>
                <div className="flex gap-2">
                  <Button data-testid="app-error-reload-button" className="rounded-full bg-violet-500 text-white hover:bg-violet-400" onClick={() => window.location.reload()}>
                    Recharger
                  </Button>
                  <Button data-testid="app-error-go-login-button" variant="outline" className="rounded-full border-white/10 bg-white/[0.08] text-slate-50 hover:bg-white/10" onClick={() => (window.location.href = "/login")}>
                    Retour login
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
